// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {getNavigationLinks} from '../shared/services/home-page-helper';

const WipItem = props =>
    <div className='wip-item'>
        <div className='count'>
            {props.count}
        </div>
        {
            props.status !== 'CLAIMS' && props.status !== 'OPEN_PIPS' ?
                <a
                    className='status'
                    href={getNavigationLinks(props.status, props.statusKey)}
                >
                    <FormattedMessage id={props.status}/>
                </a> :
                <div className='status'>
                    <FormattedMessage id={props.status}/>
                </div>
        }
        <div className='status-indicator'>
            <span className={props.className}/>
        </div>
    </div>;

WipItem.displayName = 'WipItem';
WipItem.propTypes = {
    className: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    statusKey: PropTypes.string
};

export default WipItem;



// WEBPACK FOOTER //
// ./src/home-page/components/wip-item.js